module.exports = __webpack_public_path__ + "img/img-detail-booked-default.822b3296.svg";